export default class LimitExceededError extends Error {
  constructor() {
    super("Rate limit exceeded");
  }
}
